import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap: LocalizedString = {
	[Locale.cs]: "/projekty",
	[Locale.en]: "/projects",
	[Locale.sk]: "/projekty",
};

export function getEuProjektPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
